import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, ShieldCheck } from 'lucide-react';
const HeaderGlp6TipsD = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17286">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17287"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17288">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17289">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17290">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17291">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17292">
          <div className="text-left" data-id="element-17293">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17294">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17295">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17296">
        <div className="max-w-4xl mx-auto" data-id="element-17297">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17298">
            PERSONAL REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-2" data-id="element-17299">
            6 Science-Backed Solutions for GLP-1 Side Effects
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-17300">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-17301">
              <img src="https://cdn.magicpatterns.com/uploads/qo1VVrn8u2FTESbwCETPV1/1.jpg" alt="Dr. Tom Parham" className="w-full h-full object-cover" data-id="element-17302" />
            </div>
            <div className="flex-1" data-id="element-17303">
              <div className="flex items-center" data-id="element-17304">
                <div className="font-medium text-gray-900 text-lg" data-id="element-17305">
                  By Patricia Morrison, RN, CN
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-17306">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-17307" />
                  <span className="text-xs ml-1 font-medium" data-id="element-17308">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17309">
                Chicago, IL • Former Medical Practitioner • 58 Years Old • 4
                Years on GLP-1 Medications
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-17310">
                <div className="flex items-center mr-4" data-id="element-17311">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-17312" />
                  <span data-id="element-17313">18 min read</span>
                </div>
                <div className="flex items-center" data-id="element-17314">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-17315" />
                  <span data-id="element-17316">42,372 views</span>
                </div>
              </div>
              <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-17317">
                <ShieldCheck className="h-3.5 w-3.5 text-blue-600 mr-1 flex-shrink-0" data-id="element-17318" />
                Medically Reviewed by{' '}
                <span className="text-blue-600 underline ml-1" data-id="element-17319">
                  Robert Hill, MD, FACP
                </span>
              </div>
            </div>
          </div>

          <div className="my-4" data-id="element-17320">
            <img src="https://cdn.magicpatterns.com/uploads/hE7B4t4Tu9ARxkVLjZDSCM/Title.png" alt="GLP-1 side effects" className="w-full rounded-lg shadow-lg mb-3" data-id="element-17321" />
          </div>

          <div className="my-4 border-l-4 border-gray-800 pl-6 py-4 bg-gradient-to-r from-gray-100 to-white shadow-sm" data-id="element-17322">
            <p className="text-sm uppercase tracking-wide text-gray-500 mb-2 font-semibold" data-id="element-17323">
              ARTICLE SUMMARY
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic" data-id="element-17324">
              "What a Chicago nurse discovered after three years of crushing
              depression on semaglutide:
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-17325">
              6 science-backed strategies that address nausea, hair loss,
              fatigue, and the devastating 'flat feeling' without stopping your
              medication....
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-17326">
              — now helping 120+ GLP-1 users monthly at her weight loss clinic."
            </p>
          </div>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17327">
            <div className="mb-1 flex items-center" data-id="element-17328">
              <span className="font-medium mr-2" data-id="element-17329">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-17330">
              <span className="font-medium mr-2" data-id="element-17331">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlp6TipsD;